/**
 * The version of THIS web bundle, baked in at build time (vite.config.ts `define`).
 * Sent on every API call as `x-bnb-build` so the API can tell an old barn phone
 * "please refresh" instead of failing in a confusing way.
 */
export const BUILD_VERSION: string = import.meta.env.VITE_BUILD_VERSION || 'unknown';

/** True for laptop builds (`dev-…`) — used to show a "local build" hint, never for logic. */
export function isDevBuild(version: string = BUILD_VERSION): boolean {
  return version.startsWith('dev-') || version === 'unknown';
}
